import React from 'react';

function NotFound(props) {
    return (
        <div>
            NOT FOUND
        </div>
    );
}

export default NotFound;